// frontend/src/pages/Category.js
import React, { useState, useEffect, useCallback  } from "react";
import axios from "axios";

const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com";

function Category() {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [editingID, setEditingID] = useState(null);
  const [message, setMessage] = useState("");

  const stallID = localStorage.getItem("stallID");
  const userName = localStorage.getItem("username");

  // 🔹 Fetch categories
 const fetchCategories = useCallback(async () => {
  try {
    const res = await axios.get(`${url}/api/admin/categories?stallID=${stallID}`);
    console.log("✅ Categories response:", res.data.categories);
    console.log("categories :",res.data.success);
    setCategories(res.data.categories);
   // alert(categories.length);
  } catch (err) {
    console.error("Error fetching categories:", err);
  }
}, [stallID]);

useEffect(() => {
  fetchCategories();
}, [fetchCategories]);


  // 🔹 Add / Update category
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!categoryName.trim()) {
      setMessage("⚠️ Category name cannot be empty");
      return;
    }

    try {
      if (editingID) {
        await axios.put(`${url}/api/admin/categories/${editingID}`, {
          id: editingID,
          categoryName,
          description,
        });
        setMessage("✅ Category updated");
      } else {
        await axios.post(`${url}/api/admin/categories`, {
          stallID,
          categoryName,
          description,
        });
        setMessage("✅ Category added");
      }

      // Reset form
      setCategoryName("");
      setDescription("");
      setEditingID(null);

      // Refresh list
      fetchCategories();
    } catch (err) {
      console.error("❌ Error saving category:", err);
      setMessage("⚠️ Server error");
    }
  };

  // 🔹 Edit
  const handleEdit = (cat) => {
    setEditingID(cat.id);
    setCategoryName(cat.categoryName);
    setDescription(cat.description);
  };

  // 🔹 Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;

    try {
      await axios.delete(`${url}/api/admin/categories/${id}`, {
        data: { stallID },
      });
      setMessage("🗑️ Category deleted");
      fetchCategories();
    } catch (err) {
      console.error("❌ Error deleting category:", err);
      setMessage("⚠️ Server error");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "800px" }}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "black",
          color: "white",
          padding: "40px 20px",
          borderRadius: "8px",
          marginBottom: "30px",
          textAlign: "center",
          height: "500px", // adjustable
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <h1>📂 Category Management</h1>
        <p>Manage your food stall categories</p>
        <p>{stallID}</p>
        <p>{userName}</p>
      </div>

      {/* Form */}
      <div className="card shadow p-4 mb-4">
        <h4>{editingID ? "✏️ Edit Category" : "➕ Add Category"}</h4>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="fw-bold">Category Name</label>
            <input
              type="text"
              className="form-control"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Enter category name"
              required
            />
          </div>
          <div className="mb-3">
            <label className="fw-bold">Description</label>
            <input
              type="text"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter category description"
            />
          </div>
          <button type="submit" className="btn btn-primary">
            {editingID ? "Update" : "Add"}
          </button>
        </form>
        {message && <p className="mt-3 text-danger">{message}</p>}
      </div>

      {/* Category List */}
      <table className="table table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th style={{ width: "10%" }}>ID</th>
            <th style={{ width: "30%" }}>Category Name</th>
            <th style={{ width: "40%" }}>Description</th>
            <th style={{ width: "20%" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.length > 0 ? (
            categories.map((cat) => (
              <tr key={cat.id}>
                <td>{cat.id}</td>
                <td>{cat.categoryName}</td>
                <td>{cat.description}</td>
                <td>
                  <button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() => handleEdit(cat)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(cat.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No categories found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Category;
